export default "__VITE_ASSET__DJNxCAk$__"